import type { DirectiveBinding } from 'vue'
import { Directive } from 'vue'

interface LoadingClickElement extends HTMLElement {
  _loadingClickListener?: any
  _loadingClickFunctionInstance?: any
}

const bindListener = (el: LoadingClickElement, binding: DirectiveBinding) => {
  if (el._loadingClickListener) {
    el.removeEventListener('click', el._loadingClickListener)
  }
  el._loadingClickListener = async (event) => {
    event.stopPropagation()
    if (el._loadingClickFunctionInstance) {
      return el._loadingClickFunctionInstance
    }
    const originClass = el.getAttribute('class')
    // 默认使用loading_click--loading类名，如果有自定义，在v-loading-click:loading-class中设置
    if (Object.prototype.toString.call(binding.value) === '[object Object]') {
      const { loadingClass = 'loading_click--loading', handle } = binding.value
      if (typeof handle !== 'function') {
        throw new Error('handle must be a function')
      }
      if (typeof loadingClass !== 'string') {
        throw new Error('loadingClass must be a string')
      }
      if (loadingClass) {
        el.setAttribute('class', `${originClass} ${loadingClass}`)
      }
      el._loadingClickFunctionInstance = handle
    } else {
      const loadingClass = 'loading_click--loading'
      el.setAttribute('class', `${originClass} ${loadingClass}`)
      if (typeof binding.value !== 'function') {
        throw new Error('v-loading-click must be a function')
      }
      el._loadingClickFunctionInstance = binding.value
    }
    try {
      await el._loadingClickFunctionInstance()
    } catch (error) {
      if (error === 'cancel') {
        return
      }
      throw error
    } finally {
      el._loadingClickFunctionInstance = null
      el.setAttribute('class', originClass)
    }
  }

  el.addEventListener('click', el._loadingClickListener)
}

export const loadingClick: Directive = {
  created: bindListener,
  updated: bindListener,
  unmounted(el) {
    if (el._loadingClickListener) {
      el.removeEventListener('click', el._loadingClickListener)
    }
  },
}
